import gsap from 'gsap'
import SplitText from 'gsap/SplitText'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { q1O } from '../util/nE'
gsap.registerPlugin(SplitText, ScrollTrigger)

class BackAndForth {
  constructor (el) {
    this.el = el
    this.title = this.el.querySelector('.back-and-forth__title')
    this.wysiwyg = this.el.querySelector('.wysiwyg')
    this.imageWrapper = this.el.querySelector('.back-and-forth__image')
    this.img = this.imageWrapper.querySelector('img')
  }

  init () {
    this.buildSplit()
    this.buildTimelineIn()
  }

  buildSplit () {
    if (!this.title) {
      return
    }
    this.split = new SplitText(this.title, {
      type: 'chars, words, lines',
      linesClass: 's-line u-t overflow-hidden',
      wordsClass: 's-word',
      // lineThreshold: 5,
    })
  }

  buildTimelineIn () {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        ease: (t) => {
          return q1O(t)
        },
        duration: 1,
        onStart: () => {},
      },
    })

    tl.set(this.el, { autoAlpha: 1 })

    if (this.title) {
      tl.fromTo(this.split.words, {
        yPercent: 100,
        autoAlpha: 0,
      }, {
        yPercent: 0,
        autoAlpha: 1,
        stagger: 0.01,
      }, 0)
    }

    if (this.wysiwyg) {
      tl.fromTo(this.wysiwyg, {
        yPercent: 100,
        autoAlpha: 0,
      }, {
        yPercent: 0,
        autoAlpha: 1,
      }, 0)
    }

    if (this.imageWrapper) {
      tl.to(this.imageWrapper, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        autoAlpha: 1,
        duration: 1.3,
        ease: (t) => {
          return q1O(t)
        },
      }, 0)
    }

    if (this.img) {
      tl.to(this.img, {
        scale: 1,
        duration: 1.3,
        ease: (t) => {
          return q1O(t)
        },
      }, 0)
    }
  }

  destroy () {
  }
}

export default BackAndForth



//////////////////
// WEBPACK FOOTER
// ./scripts/components/BackAndForth.js
// module id = 25
// module chunks = 0